import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash"
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {PlanningProjectsService} from "../../services/planning-projects-service.service";

export class PlanningProjectSchemeViewCtrl implements IController {
  project: any;
  status: any;
  draftIds: string[];
  selectedTab: any;


  public draftsMap: any;
  private projectRef: any;
  private draftsRefMap: any;


  /* @ngInject */
  constructor(private planningConstants, private planningDraftsService: PlanningDraftsService,
              private planningDialogService: PlanningDialogService, private $planningProjects,
              private $drafts, private planningProjectsService: PlanningProjectsService,
              private planningAlertsService: PlanningAlertsService, private $log,
              private $state, private $scope: IScope) {
  }

  $onInit() {
    this.projectRef = this.$planningProjects(this.project.id);
    this.draftsRefMap = {};
    this.draftsMap = {};

    if (!this.selectedTab) {
      this.selectedTab = 'PROJECT';
    }

    this.bindProject();
    this.setTabs(this.draftIds, []);
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {


    if (onChangesObj.draftIds && !onChangesObj.draftIds.isFirstChange()) {
      const currentDraftIds = _.get(onChangesObj.draftIds, 'currentValue'),
        previousDraftIds = _.get(onChangesObj.draftIds, 'previousValue');

      this.setTabs(currentDraftIds, previousDraftIds);
    }

    if (onChangesObj.status && _.isEqual(this.status, 'RUNNING')) {
      this.planningDialogService.draftDispatchingLoader(this.project.id, this.project.selectedDraftId)
        .then(() => {
          if (_.isEqual(this.status, 'DISPATCHED')) {
            this.planningAlertsService.approveAndDispatchDraftSuccess();
            this.goToRoutes(this.project.selectedDraftId);
          }
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
    }

  }


  // ******************************
  //        Public methods
  // ******************************

  onNavChange(tabId) {
    this.selectedTab = tabId;
    if (tabId === 'PROJECT') {
      this.$state.go('^.project', {projectId: this.project.id, draftId: undefined}, {
        notify: true,
        reload: this.planningConstants.states.projectOld
      });
    } else {
      this.$state.go('^.draft', {draftId: tabId}, {notify: true, reload: this.planningConstants.states.draftOld});
    }
  }

  onCompareDrafts(draftIds) {
    if (!draftIds || !draftIds.length) {
      draftIds = this.draftIds;
    }
    this.planningDraftsService.getDrafts(draftIds, this.project.id)
      .then((drafts) => {
        return this.planningDialogService.compareDrafts(drafts, this.project.selectedDraftId);
      })
      .then((selectedDraftId) => {
        if (!selectedDraftId) {
          this.$log.info('Dialog Closed');
        } else {
          this.setSelectedDraftInProject(selectedDraftId);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }


  // ******************************
  //        Private methods
  // ******************************


  private bindProject() {
    this.projectRef.$bindCtrl(this.$scope, this, 'project');
  }

  private setTabs(currentDraftIds: string[], previousDraftIds: string[]) {
    const draftIdsToRemove = _.differenceBy(previousDraftIds, currentDraftIds);
    const draftIdsToAdd = _.difference(currentDraftIds, previousDraftIds);

    if (_.size(draftIdsToRemove)) {
      _.forEach(draftIdsToRemove, (idToRemove) => {
        _.unset(this.draftsMap, idToRemove);

        if (this.draftsRefMap[idToRemove]) {
          this.draftsRefMap[idToRemove].$destroy();
          _.unset(this.draftsRefMap, idToRemove);
        }
      })
    }

    if (_.size(draftIdsToAdd)) {
      this.addDrafts(draftIdsToAdd);
    }
  }

  private setSelectedDraftInProject(draftId: string) {
    if (this.project.selectedDraftId !== draftId) {
      this.planningProjectsService.setSelectedDraft(this.project.id, draftId)
        .then((selectedDraft: any) => {
          this.project.selectedDraftId = selectedDraft.id;
        })
    }
  }

  private goToRoutes(draftId) {
    this.$state.go(this.planningConstants.states.completed, {draftId: draftId});
  }


  private addDrafts(draftsToAdd) {
    this.planningDraftsService.getDrafts(draftsToAdd, this.project.id)
      .then((drafts: any) => {
        _.forEach(drafts, (d) => {
          _.set(this.draftsMap, d.id, d);

          const ref = this.$drafts(d.id);
          this.draftsRefMap[d.id] = ref;

          ref.$bindCtrl(this.$scope, this, 'draftLive_', {projectId: d.projectId});
          ref.$registerOnUpdateHandler(this, (updatedDraft) => {
            if (_.isEqual(updatedDraft.id, d.id)) {
              this.$log.info('Scheme View - Draft:', updatedDraft);
              _.set(this.draftsMap, updatedDraft.id, updatedDraft);
            }
          })
        })
      })
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectSchemeView', {
    bindings: {
      project: '<',
      status: '<',
      draftIds: '<',
      selectedTab: '<?'
    },
    template: require('./planning-project-scheme-view.html').default,
    controller: PlanningProjectSchemeViewCtrl
  });
